<script >
import ChartingLeftDrawerFavoritesSection from '@/features/charting-next/components/workspace/left-drawer/ChartingLeftDrawerFavoritesSection.vue';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  entryType: {
    type: String,
    default: 'finder'
  },
  entryValue: {
    type: String,
    default: ''
  },
  favoriteFolders: {
    type: Array,
    default: () => []
  },
  selectedFolderNames: {
    type: Array,
    default: () => []
  },
  selectedTicker: {
    type: String,
    default: ''
  },
  selectedCompanyName: {
    type: String,
    default: ''
  },
  canUseFavorites: {
    type: Boolean,
    default: false
  },
  canManageFavoriteFolders: {
    type: Boolean,
    default: false
  },
  legacyHref: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const closeDialog = () => emit('update:visible', false);
  const openSource = payload => {
    emit('open-source', payload);
    closeDialog();
  };
  return {
    emit,
    openSource
  };
};
__sfc_main.components = Object.assign({
  ChartingLeftDrawerFavoritesSection
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <Dialog
        :visible="visible"
        modal
        dismissableMask
        closeOnEscape
        mask-class="charting-mobile-fullscreen-mask"
        dialog-class="charting-mobile-fullscreen-dialog"
        :dialog-style="{ width: 'calc(100vw - 2rem)', maxWidth: '48rem' }"
        @update:visible="emit('update:visible', $event)"
    >
        <template #header>
            <div>
                <div class="text-xs font-semibold uppercase tracking-wide text-muted-color">Workspaces</div>
                <div class="mt-1 text-lg font-semibold">Favoritos</div>
            </div>
        </template>

        <div class="charting-workspace-dialog-shell">
            <div class="charting-workspace-dialog-grid">
                <div class="charting-workspace-dialog-column">
                    <ChartingLeftDrawerFavoritesSection
                        :selected-ticker="selectedTicker"
                        :selected-company-name="selectedCompanyName"
                        :selected-folder-names="selectedFolderNames"
                        :favorite-folders="favoriteFolders"
                        :entry-type="entryType"
                        :entry-value="entryValue"
                        :can-use-favorites="canUseFavorites"
                        :can-manage-favorite-folders="canManageFavoriteFolders"
                        @open-source="openSource"
                        @toggle-favorite-folder="emit('toggle-favorite-folder', $event)"
                        @create-favorite-folder="emit('create-favorite-folder', $event)"
                        @rename-favorite-folder="emit('rename-favorite-folder', $event)"
                        @remove-favorite-folder="emit('remove-favorite-folder', $event)"
                    />
                </div>

            </div>
        </div>
        <template v-if="legacyHref" #footer>
            <a :href="legacyHref" target="_blank" rel="noopener noreferrer" class="charting-workspaces-classic-link">
                <i class="pi pi-external-link" aria-hidden="true"></i> Abrir en versión clásica
            </a>
        </template>
    </Dialog>
</template>

<style scoped>
.charting-workspace-dialog-shell {
    display: flex;
    min-height: 0;
    flex-direction: column;
    gap: 1rem;
}

.charting-workspace-dialog-grid {
    display: grid;
    min-height: 0;
    flex: 1 1 auto;
    gap: 1rem;
    grid-template-columns: minmax(0, 1fr);
}

.charting-workspace-dialog-column {
    display: flex;
    min-height: 0;
    flex-direction: column;
    gap: 1rem;
}

.charting-workspace-dialog-shell ::v-deep .charting-workspace-drawer-section {
    border: 0;
    border-radius: 0;
    padding: 0;
    background: transparent;
}

.charting-workspace-dialog-shell ::v-deep .charting-workspace-drawer-section + .charting-workspace-drawer-section {
    border-top: 1px solid var(--charting-b-border-color);
    padding-top: 1rem;
}

.charting-workspaces-classic-link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    min-height: 2.75rem;
    color: var(--text-color-secondary);
    font-size: 0.875rem;
}

.charting-workspaces-classic-link:focus-visible {
    outline: 2px solid var(--brand-primary);
    outline-offset: 3px;
}

@media (max-width: 1023px) {
    .charting-workspace-dialog-shell {
        max-height: none;
    }

    .charting-workspace-dialog-grid {
        grid-template-columns: 1fr;
    }

    .charting-workspace-dialog-column {
        overflow: visible;
        padding-right: 0;
    }
}
</style>
